<template>
  <div class="row">
    <div class="eight wide column">
      <div class="ui info icon message" v-if="errorMessage" style="margin-bottom:2em;">
        <i class="warning circle icon"></i>
        {{ errorMessage }}
      </div>
      <form @submit.prevent @keydown.enter.prevent id="lesson-plan-form" class="ui form">
        <h3 class="ui header" style="margin-bottom:0;"><i class="mobile alternate icon"></i>Content Creation</h3>
        <h3 class="ui dividing header" style="margin-top:0;"><span class="sub header">This is what the patient will see</span></h3>

        <div class="required field">
          <label>Lesson Title</label>
          <input v-model="currentLesson.data.title"
                 name="title" type="text" placeholder="e.g. Article Title">
        </div>

        <div class="field">
          <label>Lesson Description</label>

          <quill-editor v-model="currentLesson.data.body"
                        :options="editorOption">
          </quill-editor>
        </div>

        <div class="field">
          <label>Image Link
            <br><i style="font-weight: normal;">For security, only use links starting with "https://"</i>
          </label>

          <input v-model="currentLesson.data.imageLink"
                 type="text" name="image" placeholder="Paste URL here…">
        </div>


        <div class="fields" style="margin-bottom:0;">
          <div class="eight wide field">
            <label><b>Left Action Button</b></label>
          </div>
          <div class="eight wide field">
            <label><b>Right Action Button</b></label>
          </div>
        </div>

        <div class="fields">
          <div class="eight wide field">
            <label>Icon</label>
            <select v-model="currentLesson.data.options.secondaryIcon"
                    @change="returnNull('secondaryIcon')"
                    name="secondary-icon" class="ui fluid dropdown">
              <option value="null" selected>No Icon</option>
              <option value="download">Download</option>
              <option value="watch">Watch</option>
            </select>
          </div>

          <div class="eight wide field">
            <label>Icon</label>
            <select v-model="currentLesson.data.options.primaryIcon"
                    @change="returnNull('primaryIcon')"
                    name="primary-icon" class="ui fluid dropdown">
              <option value="null" selected>No Icon</option>
              <option value="download">Download</option>
              <option value="watch">Watch</option>
            </select>
          </div>
        </div>

        <div class="fields">
          <div class="eight wide field">
            <label>Button Label</label>
            <input v-model="currentLesson.data.options.secondaryText"
                   name="secondary-text" type="text" placeholder="Optional">
          </div>

          <div class="eight wide field">
            <label>Button Label</label>
            <input v-model="currentLesson.data.options.primaryText"
                   name="primary-text" type="text" placeholder="Optional">
          </div>
        </div>

        <div class="fields">
          <div class="eight wide field">
            <label>Link</label>
            <input v-model="currentLesson.data.options.secondaryLink"
                   name="secondary-text" type="text" placeholder="Optional">
          </div>

          <div class="eight wide field">
            <label>Link</label>
            <input v-model="currentLesson.data.options.primaryLink"
                   name="primary-text" type="text" placeholder="Optional">
          </div>
        </div>

        <br>

        <h3 class="ui dividing header">
          <i class="settings icon"></i>Admin Settings
        </h3>



        <div class="required field">
          <label>
            <i class="blue question large circle icon backoffice-glossary"
               data-content="Internal name of this action for backoffice view only."></i>
            Short Name
          </label>
          <input v-model="currentLesson.data.shortName"
                 name="short-name" type="text" placeholder="Use a short name for internal reference">
        </div>


        <div class="required field">
          <label>
            <i class="blue question large circle icon backoffice-glossary"
               data-content="Coaching Program Day when the patient starts seeing this lesson"></i>
            Start Day
          </label>
          <input v-model="currentLesson.data.options.startDay"
                 name="start-day" type="number" style="display:inline-block; width:100px !important" maxlength="3">
        </div>

        <div class="field">
          <label>Assign to Lesson Plan(s)
            <br><i style="font-weight: normal;">Leave blank if you don't want to assign it to any lesson plans.</i>
          </label>

          <select v-model="currentLesson.data.options.belongsToTemplate"
                  name="belongs-to-template" multiple class="ui fluid search dropdown">
            <option disabled value="">Not assigned</option>
            <option v-for="template in coachingLessonPlansAll"
                    v-if="template.data.deletedStatus === false"
                    :value="template.id">{{ template.data.title }}</option>
          </select>
        </div>


        <plan-template-create
          :type="'lesson'"
          :isRightFloated="true">
        </plan-template-create>

        <br>
        <br>
        <br>

        <button style=""
                @click.prevent="updateProgramItems('post')"
                v-if="$route.name === 'PageLessonPlanCreate'"
                type="submit" class="ui primary submit big button">
          Create New
        </button>
        <button @click.prevent="updateProgramItems('post', false)"
                style="margin-left: 1em; "
                v-if="$route.name === 'PageLessonPlanCreate'"
                type="submit" class="ui primary submit big basic button">
          Create and Add Another
        </button>
        <button @click.prevent="updateProgramItems('put')"
                v-if="$route.name === 'EditLessonPlan'"
                type="submit" class="ui primary submit big button">
          Save Lesson
        </button>
        <div class="ui error message"></div>
      </form>
    </div>

    <div class="five wide column">
      <div class="ui sub header">Mobile Preview</div>
      <preview-lesson-plan
        :currentLesson="currentLesson"
        ></preview-lesson-plan>
    </div>

  </div>
</template>

<script>
  import 'quill/dist/quill.snow.css'
  import { quillEditor } from 'vue-quill-editor'
  import PreviewLessonPlan from './PreviewLessonPlan.vue'
  import PlanTemplateCreate from './PlanTemplateCreate.vue'
  import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
  import dataStructure from '../../validation/dataStructure'

	export default {
    props: {
      lessonid: {
        default: function(){
          return this.$route.params.lessonid
        }
      },
      errorMessage: {
        default: function(){
          return this.$route.params.errorMessage
        }
      }
    },
    components: {
      PreviewLessonPlan,
      PlanTemplateCreate,
      quillEditor
    },
		data() {
			return {
        previousTemplateArray: [],
        currentLesson: JSON.parse(JSON.stringify(dataStructure.lessonStructure)),
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic'],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              ['link']
            ]
          },
          placeholder: 'Write the lesson plan here…',
        }
      }
		},
		computed: {
      ...mapState(['coachingLessonPlansAll']),
    },
		methods: {
      ...mapMutations(['addNewLesson', 'removeSelectedLesson']),
      // TODO: This converts the text string 'null' returned from dropdown list to actual `null`. It should be moved out for reusability.
      getCurrentLesson(id){
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlans/' + id;

        this.$http.get(requestUrl).then((response) => {
          //checks if planType is correct else redirect to correct followup page
          if (response.body.result.planType === 'lesson') {
            //sets values if planType is correct
            this.currentLesson = Object.assign({}, response.body.result);
            this.currentLesson.data = Object.assign({}, dataStructure.lessonStructure.data, response.body.result.data);
            this.previousTemplateArray = this.currentLesson.data.options.belongsToTemplate;
            window.requestAnimationFrame(()=>{
              $('.ui.dropdown').dropdown();
            });
          }
          else if (response.body.result.planType === 'action'){
            this.$router.push({ name: 'EditActionPlan', params: { actionid: id }});
          }
        }, (error) => {

          if (error.status !== 404) {
            Rollbar.error("failed to fetch planID as lesson: " + id, error);
          }

          this.$router.push({ name: 'PageLessonPlanCreate', params: { errorMessage:  "The requested lesson id: " + id + " does not exist. Create a new lesson instead?" }  });

        });
      },
      returnNull(key) {
        if (this.currentLesson.data.options[key]  === 'null') {
          this.currentLesson.data.options[key] = null;
        }
      },
      constructLessonObject(){
        this.currentLesson.data.lastModifiedTime = new Date().getTime();
        this.currentLesson.data.lastModifiedByUser = this.userEmail;
        return this.currentLesson;
      },
      initFormValidation() {
        let onlyHttps = 'regExp[/^https:///]';
        let hasImageExtension = 'regExp[/\\.(?:jpe?g|gif|png|bmp)$/]';
        let checkWholeURL= 'regExp[/^(?:(?:https?):\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-z\u00a1-\uffff]{2,}))\\.?)(?::\\d{2,5})?(?:[/?#]\\S*)?$/i]';

        $('#lesson-plan-form').form({
          fields: {
            'title': {
              // Cannot be empty
              identifier: 'title',
              rules: [
                { type: 'empty', prompt: 'Lesson Plan Title cannot be empty' },
                {type: 'maxLength[255]', prompt : 'Please enter at most 255 characters'}
              ]
            },
            'image' : {
              identifier: 'image',
              optional: true,
              rules: [
                // { type: 'url', prompt: 'Please enter a valid link' },
                { type: checkWholeURL, prompt: 'Please enter a valid link' },
                { type: onlyHttps, prompt: 'Please use an image link that starts with "https://"' },
                { type: hasImageExtension, prompt: 'Please provide a link to common types of image, e.g., "jpg", "jpeg", "png", "gif "or "bmp"' }
              ]
            },
            'primary-text': {
              identifier: 'primary-text',
              optional: true

            },
            'secondary-text': {
              identifier: 'secondary-text',
              optional: true
            },
            'primary-link': {
              // FIXME: Check for a valid URL if `primary-text` is filled
              identifier: 'primary-link',
              optional: true,
              depends: 'primary-text', // Not sure if it works
              rules: [
                // { type: 'url', prompt: 'Please enter a valid url' },
                { type: checkWholeURL, prompt: 'Please enter a valid link' }
              ]
            },
            'secondary-link': {
              // FIXME: Check for a valid URL if `secondary-text` is filled
              identifier: 'secondary-link',
              optional: true,
              depends: 'secondary-text', // Not sure if it works
              rules: [
                // { type: 'url', prompt: 'Please enter a valid link' },
                { type: checkWholeURL, prompt: 'Please enter a valid link' }
              ]
            },
            'short-name': {
              // Cannot be empty
              identifier: 'short-name',
              rules: [
                { type: 'empty', prompt: 'Short Name cannot be empty'}
              ]
            },
            'start-day': {
              // Must not be negative and less than `end-day`
              identifier: 'start-day',
              rules: [
                {type: 'not[-0]', prompt: 'Enter a valid, positive whole number'},
                {type: 'doesntContain[-]', prompt: 'Start Day cannot be negative'},
                {type: 'not[0]', prompt: 'Start Day cannot be 0'},
                {type: 'integer', prompt: 'Start Day must be whole number'},
                {type: 'integer[1..300]', prompt: 'Start Day must be a whole number between 1 to 300'}
              ]
            }
          },
          inline: true
        });
      },
      updateProgramItems(apiCallMethod, redirect = true) {
        //TODO: When posting, the buttons needs loadingState for validation!!
        let requestUrl = process.env.API_URL + process.env.PROGRAM_ID + '/programPlan';
        let validationStatus = $('#lesson-plan-form').form('is valid');

        if (validationStatus === true){
          if (apiCallMethod === 'post') {
            this.$http.post(requestUrl, this.constructLessonObject()).then( (response) => {
              this.currentLesson.id = response.body.result.id;
              this.updateProgramPlans(this.previousTemplateArray, this.currentLesson, this.coachingLessonPlansAll);

              if (redirect === true) {
                this.getProgramItems().then(()=> {
                  this.$router.push({name: 'LessonPlan'});
                })
              }
              else {
                this.getProgramItems().then(()=> {
                  this.currentLesson = JSON.parse(JSON.stringify(dataStructure.lessonStructure));
                  window.scrollTo(0,0);
                })
              }
            });
          }
          else {
            this.$http.put(requestUrl, this.constructLessonObject()).then( (response) => {
              this.updateProgramPlans(this.previousTemplateArray, this.currentLesson, this.coachingLessonPlansAll);
              this.getProgramItems().then(()=> {
                this.$router.push({name: 'LessonPlan'});
              })
            });
          }
        }
        else {
          $('#lesson-plan-form').form('validate form');
          $('#lesson-plan-form').form('add errors', ['One or more required fields are empty or contain errors.'])

        }
      },
    },
    watch: {
      '$route' (to, from) {
        if (this.$route.params.lessonid !== 'undefined' && isNaN(this.$route.params.lessonid ) === false) {
          this.$router.go({ name: 'EditLessonPlan', params: { lessonid: this.$route.params.lessonid }});
        }
      }
    },
		mounted() {
      $('.ui.dropdown').dropdown();
      $('.backoffice-glossary').popup();
      // If lesson plan exists, load in all the data
      if (typeof(this.lessonid) !== 'undefined') {
        this.getCurrentLesson(this.lessonid);
      }

      this.initFormValidation();
    }
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/content/LessonPlanCreateEdit.vue